import { render, staticRenderFns } from "./ProductSegmentation.vue?vue&type=template&id=084c1af3&scoped=true&"
import script from "./ProductSegmentation.vue?vue&type=script&lang=js&"
export * from "./ProductSegmentation.vue?vue&type=script&lang=js&"
import style0 from "./ProductSegmentation.vue?vue&type=style&index=0&id=084c1af3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c1af3",
  null
  
)

export default component.exports